import type { NavigationConfig } from '@ingenico/react-section-utils';
import { listenCapabilities } from '@ingenico/react-section-utils';
import type { DeviceManagementSpiPort } from './domain/hexa/ports/spi.model';

export function deviceManagementTenantNavigation(spi: DeviceManagementSpiPort): NavigationConfig {
  return [
    {
      labelKey: 'navigation.page.appstore',
      icon: 'services',
      order: 20,
      children: [
        {
          labelKey: 'navigation.page.apps',
          href: 'apps',
          onlyShowWhen: listenCapabilities(spi, [], ['apps.showInGlobalNavigation', 'apps.list']),
        },
        {
          labelKey: 'navigation.page.os',
          href: 'os',
          onlyShowWhen: listenCapabilities(spi, [], ['os.showInGlobalNavigation', 'os.list']),
        },
        {
          labelKey: 'navigation.page.systemPackages',
          href: 'system-packages',
          onlyShowWhen: listenCapabilities(spi, [], ['systemPackages.showInGlobalNavigation', 'systemPackages.list']),
        },
        {
          labelKey: 'navigation.page.resources',
          href: 'resources',
          onlyShowWhen: listenCapabilities(spi, [], ['resources.showInGlobalNavigation', 'resources.list']),
        },
        {
          labelKey: 'navigation.page.rki',
          href: 'rki',
          onlyShowWhen: listenCapabilities(spi, [], ['rki.showInGlobalNavigation', 'rki.detail']),
        },
      ],
    },
  ];
}
